// API endpoints for production

export const USER_API_END_POINT="https://www.hirees.com/api/v1/user";
export const JOB_API_END_POINT="https://www.hirees.com/api/v1/job";
export const APPLICATION_API_END_POINT="https://www.hirees.com/api/v1/application";
export const COMPANY_API_END_POINT="https://www.hirees.com/api/v1/company";
export const SAVED_JOBS_API_END_POINT="https://www.hirees.com/api/v1/savedjobs";
export const FEEDBACK_API_END_POINT = "https://www.hirees.com/api/v1/feedback";
export const RESUME_API_END_POINT = "https://www.hirees.com/api/v1/bulk-resume";
export const RECRUITER_API_END_POINT = "https://www.hirees.com/api/v1/recruiter";


// for local development, you can use the following endpoints: 

// export const USER_API_END_POINT = "http://localhost:8000/api/v1/user";
// export const JOB_API_END_POINT="http://localhost:8000/api/v1/job"; 
// export const APPLICATION_API_END_POINT="http://localhost:8000/api/v1/application"; 
// export const COMPANY_API_END_POINT="http://localhost:8000/api/v1/company";
// export const SAVED_JOBS_API_END_POINT="http://localhost:8000/api/v1/savedjobs";
// export const FEEDBACK_API_END_POINT = "http://localhost:8000/api/v1/feedback";
// export const RESUME_API_END_POINT = "http://localhost:8000/api/v1/bulk-resume"; 
// export const RECRUITER_API_END_POINT = "http://localhost:8000/api/recruiter";


// const BASE_URL = import.meta.env.VITE_API_BASE_URL;

// export const USER_API_END_POINT = `${BASE_URL}/api/v1/user`;
// export const JOB_API_END_POINT = `${BASE_URL}/api/v1/job`;
// export const APPLICATION_API_END_POINT = `${BASE_URL}/api/v1/application`;
// export const COMPANY_API_END_POINT = `${BASE_URL}/api/v1/company`;
// export const SAVED_JOBS_API_END_POINT = `${BASE_URL}/api/v1/savedjobs`;
